import Vue from 'vue'
import { VueGoodTable } from 'vue-good-table'
import Sortable from 'sortablejs'
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import formatFunctons from '@/components/mixins/format-functions'
import ConfirmModal from '@/components/modals/confirm-modal/confirm-modal.vue'
import IcClose from '@/assets/svg/ic-close.svg?inline'
import IcSelect from '@/assets/svg/ic-select.svg?inline'
import IcBicycle from '@/assets/svg/ic_bicycle.svg?inline'
import IcCar from '@/assets/svg/ic-car.svg?inline'
import addMapScript from '@/utils/addMapScript'
import { getOrderId } from '@/utils/getOrderId'
import DeleteRouteModal from '@/components/modals/delete-route-task-with-reason/delete-route-task-modal.vue'

export default {
  name: 'Map',
  /**
   * getFormatDate
   * getShortId
   * getCookedTime
   */
  mixins: [formatFunctons],
  components: {
    VueGoodTable,
    ConfirmModal,
    DeleteRouteModal,
    IcClose,
    IcSelect,
    IcBicycle,
    IcCar
  },
  data() {
    return {
      /**
       * Объект который позволяет делать drag and drop
       */
      sortable: null,
      /**
       * чтобы не было конфликтов при перерерисовке при drag and drop
       */
      tableKey: 0,
      /***/
      mapObject: null,
      courierMarker: null,
      inRouteTimesCalc: [],
      remainingTimeCalc: [],
      isOpenSuccessAlert: false,
      successAlertTimeout: null,
      courierLocationTimeout: null,
      prevCourierPhotoSrc: '',
      mapOptions: {
        isFootCourier: false
      },
      changeRoutesPending: false,
      table: {
        columns: [
          {
            label: '№ заказа',
            field: 'id',
            type: 'number',
            sortable: false,
            tdClass: 'order-id-td',
            thClass: 'order-id-td'
          },
          {
            label: 'Адрес',
            field: 'address.full_address',
            sortable: false
          },
          {
            label: 'Доставить',
            field: 'times.delivery_to',
            sortable: false
          },
          {
            label: 'Запас',
            field: 'remaining_time',
            sortable: false
          },
          {
            label: 'Готовность',
            field: 'times.cooked_at',
            sortable: false
          },
          {
            label: 'В пути',
            field: 'in_route',
            sortable: false
          }
        ]
      },
      successMsgs: {
        changeInfoRoutes: 'Данные о маршруте отправлены',
        removeRouteTask: 'Примите на планшете заказы из Маршрута, чтобы можно было его удалить'
      },
      successMessage: ''
    }
  },
  computed: {
    ...mapState({
      editedRouteTask: state => state.routeTasks.editedRouteTask,
      editedRouteTaskInfo: state => state.routeTasks.editedRouteTaskInfo,
      courierLocation: state => state.routeTasks.courierLocation,
      manufacturePoint: state => state.manufactures.selectedManufacture,
      mapApiLoading: state => state.mapLoading.loading,
      mapApiIndex: state => state.mapLoading.apiIndex,
      orderStatuses: state => state.sharedData.orderStatuses
    }),
    ...mapGetters({
      isAutoRouteTaskActive: 'logistics/isAutoRouteTaskActive' // Теперь это вычисляемое свойство
    }),
    manufactureCoords() {
      if (this.editedRouteTaskInfo?.manufacture) {
        return [
          +this.editedRouteTaskInfo.manufacture.coordinates.lat,
          +this.editedRouteTaskInfo.manufacture.coordinates.lng
        ]
      } else {
        return [+this.manufacturePoint.coordinates.lat, +this.manufacturePoint.coordinates.lng]
      }
    }
  },
  mounted() {
    if (!(this.editedRouteTaskInfo && this.editedRouteTaskInfo.is_forced_finished)) {
      this.setSortable()
    }
    this.createMap()
    window.addEventListener('keydown', this.onEscPress)
  },
  beforeDestroy() {
    this.clearTimeouts()
    window.removeEventListener('keydown', this.onEscPress)
  },
  methods: {
    ...mapActions({
      createRouteTask: 'routeTasks/createRouteTask',
      updateRouteTask: 'routeTasks/updateRouteTask',
      removeRouteTask: 'routeTasks/removeRouteTask',
      getCourierLocation: 'routeTasks/getCourierLocation',
      cancelCourierLocation: 'routeTasks/cancelCourierLocation'
    }),
    ...mapMutations({
      setEditedRouteTask: 'routeTasks/SET_EDITED_ROUTE_TASK',
      setEditedRouteTaskInfo: 'routeTasks/SET_EDITED_ROUTE_TASK_INFO',
      setApiIndex: 'mapLoading/SET_API_INDEX'
    }),
    getOrderId,
    /**
     *
     * @param {*} msgKey - changeInfoRoutes | removeRouteTask
     */
    showSuccessMsgAlert(msgKey) {
      clearTimeout(this.successAlertTimeout)
      this.successAlertTimeout = null
      this.successMessage = this.successMsgs[msgKey]
      this.isOpenSuccessAlert = true
      this.successAlertTimeout = setTimeout(() => {
        this.isOpenSuccessAlert = false
      }, 10000)
    },
    /**
     *
     * actionName - createRouteTask | updateRouteTask
     */
    async changeInfoRoutes(actionName) {
      const allowedByFootCourier = this.mapOptions.isFootCourier
      try {
        this.changeRoutesPending = true
        await this[actionName]({ allowedByFootCourier })
        this.changeRoutesPending = false
        this.$emit(actionName)
        this.showSuccessMsgAlert('changeInfoRoutes')
      } catch (e) {
        this.changeRoutesPending = false
      }
    },
    closeSuccessAlert() {
      this.isOpenSuccessAlert = false
      clearTimeout(this.successAlertTimeout)
      this.successAlertTimeout = null
    },
    createMap() {
      if (!this.mapApiLoading) {
        this.mapObject = new window.ymaps.Map(
          this.$refs.map,
          {
            center: this.manufactureCoords, // Используем manufactureCoords
            zoom: 9,
            controls: []
          },
          {
            maxZoom: 15,
            suppressMapOpenBlock: true
          }
        )
      }
    },
    async setCourierLocationTimeout() {
      if (!this.mapApiLoading) {
        if (!this.mapObject) {
          this.createMap()
        }
        await this.getCourierLocation(this.editedRouteTaskInfo.route_task_id)
        if (this.courierLocation && this.courierLocation.geo_location) {
          const geoLocationCoords = [
            +this.courierLocation.geo_location.lat,
            +this.courierLocation.geo_location.lng
          ]
          let iconContainer
          if (this.courierLocation.courier.is_foot_courier) {
            iconContainer = document.createElement('div')
            const iconInstance = new Vue({
              render(h) {
                return h(IcBicycle)
              }
            })
            iconInstance.$mount()
            iconContainer.appendChild(iconInstance.$el)
          }

          const getPlacemarkLayout = () =>
            window.ymaps.templateLayoutFactory.createClass(
              `<div class="courier-marker">
              <img src="${this.courierLocation.courier.photo_url}"/>
              ${
                this.courierLocation.courier.is_foot_courier
                  ? `
                  <div class="courier-marker__icon">
                    ${iconContainer.innerHTML}
                  </div>
                `
                  : ''
              }
            </div>`
            )

          const hintContent = `${this.courierLocation.courier.first_name} ${this.courierLocation.courier.last_name}`

          if (!this.courierMarker) {
            this.courierMarker = new window.ymaps.Placemark(
              geoLocationCoords,
              {
                hintContent
              },
              {
                iconLayout: getPlacemarkLayout(),
                iconShape: {
                  type: 'Rectangle',
                  // АКТИВНАЯ область метки
                  coordinates: [
                    [-19, -19],
                    [38, 19]
                  ]
                }
              }
            )
            this.mapObject.geoObjects.add(this.courierMarker)
            this.prevCourierPhotoSrc = this.courierLocation.courier.photo_url
          } else {
            this.courierMarker.geometry.setCoordinates(geoLocationCoords)
            if (this.prevCourierPhotoSrc !== this.courierLocation.courier.photo_url) {
              this.courierMarker.options.set('iconLayout', getPlacemarkLayout())
              this.prevCourierPhotoSrc = this.courierLocation.courier.photo_url
            }
            this.courierMarker.properties.set('hintContent', hintContent)
          }
        }
        this.courierLocationTimeout = setTimeout(this.setCourierLocationTimeout, 10000)
      }
    },
    addRouteOnMap() {
      const manufactureCoords = this.manufactureCoords // Используем manufactureCoords
      if (!this.mapApiLoading) {
        if (!this.mapObject) {
          this.createMap()
        }
        this.mapObject.geoObjects.removeAll()
        this.courierMarker = null

        const multiRoute = new window.ymaps.multiRouter.MultiRoute(
          {
            referencePoints: [
              manufactureCoords,
              ...this.editedRouteTask.map(order => {
                return [+order.address.lat, +order.address.lng]
              })
            ],
            params: {
              avoidTrafficJams: true,
              results: 1,
              routingMode: this.mapOptions.isFootCourier ? 'bicycle' : 'auto'
            }
          },
          {
            boundsAutoApply: true,
            wayPointVisible: false
          }
        )

        this.mapObject.geoObjects.add(multiRoute)

        this.mapObject.geoObjects.add(
          new window.ymaps.Placemark(
            manufactureCoords,
            {
              hintContent:
                this.editedRouteTaskInfo?.manufacture?.title || this.manufacturePoint.title // Используем manufactureCoords
            },
            {
              iconLayout: 'default#image',
              iconImageHref: 'images/ic-map-pin.svg',
              iconImageSize: [22, 30],
              iconImageOffset: [-11, -30]
            }
          )
        )

        this.editedRouteTask.forEach((order, index) => {
          const placemarkLayout = window.ymaps.templateLayoutFactory.createClass(
            `<div class="placemark-point">${index + 1}</div>`
          )
          const placeMark = new window.ymaps.Placemark(
            [+order.address.lat, +order.address.lng],
            {
              hintContent: order.address.full_address
            },
            {
              iconLayout: placemarkLayout,
              iconShape: {
                type: 'Rectangle',
                coordinates: [
                  [-9, -9],
                  [18, 9]
                ]
              }
            }
          )
          this.mapObject.geoObjects.add(placeMark)
        })

        const addInfoDurations = () => {
          const activeRoute = multiRoute.getActiveRoute()
          if (activeRoute) {
            const activeRoutePaths = activeRoute.getPaths()
            const inRouteDurs = []
            this.remainingTimeCalc = []
            this.inRouteTimesCalc = []
            activeRoutePaths.each(path => {
              const durationInfo = this.mapOptions.isFootCourier
                ? path.properties.get('duration')
                : path.properties.get('durationInTraffic')
              inRouteDurs.push(durationInfo.value)
            })

            const cookedInTime = this.editedRouteTask
              .map(o => {
                let time = this.$moment()
                if (
                  o.times.cooked_at &&
                  this.orderStatuses[o.status].order_number < this.orderStatuses.cooked.order_number
                ) {
                  time = this.$moment(o.times.cooked_at)
                }
                return time
              })
              .reduce((a, b) => (a.diff(b) > 0 ? a : b))

            this.editedRouteTask.forEach((o, index) => {
              const prevTimeInRoute = this.inRouteTimesCalc[index - 1]
                ? this.inRouteTimesCalc[index - 1].clone()
                : this.$moment()
              this.inRouteTimesCalc.push(
                prevTimeInRoute.add(inRouteDurs[index], 'seconds').add(2, 'minutes')
              )
              const deliveryToTime = this.$moment(o.times.delivery_to)

              const deliveryDurAll = deliveryToTime.diff(cookedInTime, 'seconds')
              const deliveryTransferDiff =
                deliveryDurAll - this.inRouteTimesCalc[index].diff(this.$moment(), 'seconds')
              this.remainingTimeCalc.push(this.$moment().add(deliveryTransferDiff, 'seconds'))
            })
          } else {
            this.inRouteTimesCalc = []
            this.remainingTimeCalc = []
          }
        }

        multiRoute.model.events
          .add('requestsuccess', () => {
            addInfoDurations()
          })
          .add('requestfail', () => {
            window.ymaps = undefined
            addMapScript(apiIndex => {
              this.setApiIndex(apiIndex)
              this.addRouteOnMap()
            }, this.mapApiIndex + 1)
          })
      }
    },
    changeIndex(oldIndex, newIndex) {
      const eitedRouteCopy = [...this.editedRouteTask]
      if (newIndex >= 0 && newIndex <= eitedRouteCopy.length - 1) {
        const changedOrder = eitedRouteCopy.splice(oldIndex, 1)
        const restedRoute = eitedRouteCopy.splice(newIndex)
        this.setEditedRouteTask([...eitedRouteCopy, ...changedOrder, ...restedRoute])
        if (this.editedRouteTaskInfo) {
          this.setEditedRouteTaskInfo({
            ...this.editedRouteTaskInfo,
            changed: true
          })
        }
      }
    },
    createSortable() {
      if (this.sortable && this.sortable.el) {
        this.sortable.destroy()
      }
      const tbody = this.$refs.table.$el.querySelector('tbody')
      this.sortable = Sortable.create(tbody, {
        onEnd: evt => {
          this.changeIndex(evt.oldIndex, evt.newIndex)
        }
      })
    },
    setSortable() {
      if (this.$refs.table) {
        const tbody = this.$refs.table.$el.querySelector('tbody')
        this.sortable = Sortable.create(tbody)
      }
    },
    closeMap() {
      this.setEditedRouteTask([])
      this.setEditedRouteTaskInfo(null)
    },
    toggleFootCourier() {
      if (this.editedRouteTaskInfo) {
        this.setEditedRouteTaskInfo({
          ...this.editedRouteTaskInfo,
          allowed_by_foot_courier: !this.mapOptions.isFootCourier,
          changed: true
        })
      } else {
        this.mapOptions.isFootCourier = !this.mapOptions.isFootCourier
        this.addRouteOnMap()
      }
    },
    // async removeRTConfirm() {
    //   await this.removeRouteTask()
    //   this.showSuccessMsgAlert('removeRouteTask')
    // },
    calculateReservedTime() {
      if (!this.remainingTimeCalc.length) return []

      // Возвращаем массив разниц времени для каждого заказа
      return this.remainingTimeCalc.map(time => {
        return time.diff(this.$moment(), 'minutes')
      })
    },
    calculateTravelTime() {
      if (!this.inRouteTimesCalc.length) return []

      let totalTime = 0

      return this.inRouteTimesCalc.map((time, index) => {
        let segmentTime

        if (index === 0) {
          // Первый сегмент: от текущего времени до первой точки
          segmentTime = time.diff(this.$moment(), 'minutes')
        } else {
          // Последующие сегменты: разница с предыдущей точкой
          segmentTime = time.diff(this.inRouteTimesCalc[index - 1], 'minutes')
        }

        // Добавляем 2 минуты к текущему сегменту (как в addInfoDurations)
        //segmentTime += 2;

        //Суммируем с общим временем
        totalTime += segmentTime

        return totalTime
      })
    },
    async removeRTConfirm(formData = null) {
      try {
        if (formData) {
          const reservedTimes = this.calculateReservedTime()
          const travelTimes = this.calculateTravelTime()
          // const ordersWithDurations = this.addInfoDurations(this.editedRouteTask);

          // Создаем массив данных для каждого заказа
          const ordersData = this.editedRouteTask.map((order, index) => ({
            order_id: getOrderId(order),
            reason: formData.reason_key,
            comment: formData.comment,
            reserved_time_minutes: reservedTimes[index], // reservedTimes[index] || 0,
            travel_time_minutes: travelTimes[index]
          }))

          await this.removeRouteTask(ordersData)
        } else {
          await this.removeRouteTask()
        }
        this.closeMap()
      } catch (error) {
        console.error('Error removing route task:', error)
      }
    },
    async onConfirmRemove() {
      // Закрываем confirm-modal
      this.$refs['confirm-remove-modal'].hide?.()

      // После подтверждения показываем delete-route-modal
      this.$nextTick(() => {
        if (this.editedRouteTaskInfo.is_auto && this.isAutoRouteTaskActive) {
          this.$refs['delete-route-modal'].show()
        } else {
          this.removeRouteTask()
        }
      })
    },
    onRemoveRT() {
      if (this.editedRouteTaskInfo.courier) {
        this.$refs['confirm-remove-modal'].show()
      } else if (this.editedRouteTaskInfo.is_auto && this.isAutoRouteTaskActive) {
        this.$refs['delete-route-modal'].show()
      } else {
        this.removeRouteTask()
      }
    },
    onEscPress(e) {
      if (e.key === 'Escape') {
        this.closeMap()
      }
    },
    mapApiRouteTaskWatch() {
      this.tableKey = this.tableKey === 0 ? 1 : 0
      this.$nextTick(() => {
        this.createSortable()
        this.addRouteOnMap()
        if (this.editedRouteTaskInfo && this.editedRouteTaskInfo.courier) {
          this.setCourierLocationTimeout()
        }
      })
    },
    async clearTimeouts() {
      clearTimeout(this.successAlertTimeout)
      this.successAlertTimeout = null
      clearTimeout(this.courierLocationTimeout)
      this.courierLocationTimeout = null
      await this.cancelCourierLocation()
      if (this.mapObject && this.courierMarker) {
        this.mapObject.geoObjects.remove(this.courierMarker)
      }
    }
  },
  watch: {
    mapApiLoading() {
      this.clearTimeouts().then(() => {
        this.mapApiRouteTaskWatch()
      })
    },
    editedRouteTask() {
      this.clearTimeouts().then(() => {
        this.mapApiRouteTaskWatch()
      })
    },
    'editedRouteTaskInfo.allowed_by_foot_courier': {
      immediate: true,
      handler(data) {
        this.mapOptions.isFootCourier = data
        this.$nextTick(() => {
          this.addRouteOnMap()
        })
      }
    },
    'editedRouteTaskInfo.is_forced_finished': {
      handler(data) {
        if (data && this.sortable) {
          this.sortable.destroy()
        } else if (!data) {
          this.setSortable()
        }
      }
    }
  }
}
